import React from "react";
import { Button } from "antd";
import "./Styles/LinkButton.scss";

const LinkButton = ({ onClick, label, disabled, className }) => (
  <Button
    type="link"
    className={className}
    onClick={onClick}
    disabled={disabled}
  >
    {label}
  </Button>
);

LinkButton.defaultProps = {
  className: "",
  label: "",
  disabled: false,
};

export default LinkButton;
